"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkflowAnalytics = void 0;
var react_1 = require("react");
function useWorkflowAnalytics(options) {
    var workflowName = options.workflowName, analyticsClient = options.analyticsClient, isComplete = options.isComplete;
    var _a = (0, react_1.useState)(false), workflowStarted = _a[0], setWorkflowStarted = _a[1];
    (0, react_1.useEffect)(function () {
        if (!workflowStarted) {
            analyticsClient.track({ event: "Workflow Started", properties: { name: workflowName } });
            setWorkflowStarted(true);
        }
    }, [workflowStarted, analyticsClient, workflowName]);
    (0, react_1.useEffect)(function () {
        if (isComplete) {
            analyticsClient.track({ event: "Workflow Ended", properties: { name: workflowName } });
        }
    }, [isComplete, analyticsClient, workflowName]);
}
exports.useWorkflowAnalytics = useWorkflowAnalytics;
